<template>
    <!-- 我的推广 -->
    <div ref="headWrap" class="zhai-head-wrap">
        <ZhaiHeadPC class="zhai-head"></ZhaiHeadPC>
    </div>

    <div class="page-wrap" :style="{ '--head-h': headH + 'px' }">
        <div class="container errong">
            <div class="container-fluid">
                <div class="row shengse mt-2">
                    <div class="px-3 py-2 d-flex justify-content-between">
                        <div class="lf">
                            <i class="fa fa-bullhorn"></i> 推广中心
                        </div>
                    </div>
                </div>
            </div>

            <!-- 数据概览-->
            <div class="stats-grid">
                <div class="stat-card">
                    <div class="stat-label">今日收入（元）</div>
                    <div class="stat-value">{{ todayIncome.toFixed(2) }}</div>
                    <div class="stat-foot">
                        <span class="muted">更新时间：</span>
                        <span class="muted">{{ lastUpdate }}</span>
                    </div>
                </div>

                <div class="stat-card">
                    <div class="stat-label">昨日收入（元）</div>
                    <div class="stat-value">{{ yesterdayIncome.toFixed(2) }}</div>
                    <div class="stat-foot muted">统计口径：自然日</div>
                </div>

                <div class="stat-card">
                    <div class="stat-label">我的客户</div>
                    <div class="stat-value">{{ myCustomers }}</div>
                    <div class="stat-foot muted">包含历史累计</div>
                </div>

                <div class="stat-card">
                    <div class="stat-label">累计收入（元）</div>
                    <div class="stat-value">{{ totalIncome.toFixed(2) }}</div>
                    <div class="stat-foot muted">不含提现手续费</div>
                </div>
            </div>

            <!-- 主体左右分栏 -->
            <div class="main-grid">
                <!-- 左侧 -->
                <div class="left-col">
                    <div class="panel">
                        <div class="panel-title">快捷入口</div>

                        <div class="menu-list">
                            <div class="menu-item" @click="goCustomers">
                                <div class="mi-left">
                                    <div class="mi-icon"><i class="fa fa-user"></i></div>
                                    <div class="mi-text">
                                        <div class="mi-title">我的客户</div>
                                        <div class="mi-desc">查看通过你推广注册的用户</div>
                                    </div>
                                </div>
                                <div class="mi-right">›</div>
                            </div>

                            <div class="menu-item" @click="goPoster">
                                <div class="mi-left">
                                    <div class="mi-icon"><i class="fa fa-picture-o"></i></div>
                                    <div class="mi-text">
                                        <div class="mi-title">我的推广海报</div>
                                        <div class="mi-desc">生成/下载海报，适合朋友圈群聊分享</div>
                                    </div>
                                </div>
                                <div class="mi-right">›</div>
                            </div>

                            <div class="menu-item" @click="goDetail">
                                <div class="mi-left">
                                    <div class="mi-icon"><i class="fa fa-list-alt"></i></div>
                                    <div class="mi-text">
                                        <div class="mi-title">推广明细</div>
                                        <div class="mi-desc">查看订单/返佣/结算记录</div>
                                    </div>
                                </div>
                                <div class="mi-right">›</div>
                            </div>

                            <!-- ✅ 申请提现：弹窗确认 -->
                            <div class="menu-item" @click="openWithdrawModal">
                                <div class="mi-left">
                                    <div class="mi-icon"><i class="fa fa-credit-card"></i></div>
                                    <div class="mi-text">
                                        <div class="mi-title">申请提现</div>
                                        <div class="mi-desc">设置提现账户并提交申请</div>
                                    </div>
                                </div>
                                <div class="mi-right">›</div>
                            </div>

                            <div class="menu-item" @click="goRules">
                                <div class="mi-left">
                                    <div class="mi-icon"><i class="fa fa-book"></i></div>
                                    <div class="mi-text">
                                        <div class="mi-title">推广规则</div>
                                        <div class="mi-desc">必读：返佣说明、结算周期、注意事项</div>
                                    </div>
                                </div>
                                <div class="mi-right mi-tag">必读 ›</div>
                            </div>
                        </div>
                    </div>

                    <div class="panel">
                        <div class="panel-title">提示</div>
                        <div class="tips">
                            <div class="tip-item">
                                <i class="fa fa-info-circle"></i>
                                <span>建议优先使用「防屏蔽链接」在微信/QQ内分享。</span>
                            </div>
                            <div class="tip-item">
                                <i class="fa fa-shield"></i>
                                <span>若推广链接被拦截，重新生成防屏蔽链接即可。</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 右侧 -->
                <div class="right-col">
                    <div class="panel">
                        <div class="panel-title">推广链接</div>

                        <!-- 推广链接 -->
                        <div class="field">
                            <div class="field-label">我的推广链接</div>
                            <div class="field-row">
                                <input
                                        class="input"
                                        v-model="promoLink"
                                        readonly
                                        title="点击复制"
                                        @click="onPromoInputClick"
                                />

                                <button class="btn-primary" @click="copyPromoLinkAndModal">
                                    <i class="fa fa-copy"></i> 复制
                                </button>
                            </div>
                            <div class="field-help muted">点击复制后，可直接粘贴到浏览器或分享给好友</div>
                        </div>

                        <div class="divider"></div>

                        <!-- ✅ 防屏蔽链接-->
                        <div class="field">
                            <div class="wxqq-head">
                                <div class="wxqq-title">微信 / QQ 推广专用（防屏蔽）</div>

                                <div class="wxqq-actions">
                                    <button class="btn-green" :disabled="genLoading" @click="genAntiBlockLink">
                                        <i class="fa fa-magic"></i>
                                        {{ genLoading ? "生成中..." : "点击生成专属防屏蔽链接" }}
                                    </button>
                                </div>
                            </div>

                            <!-- 未生成：只展示文案 -->
                            <div v-if="!antiBlockLink" class="wxqq-box">
                                <div class="wxqq-box-bd">
                                    <div class="wxqq-line wxqq-text">【{{ shareText }}】</div>
                                </div>
                            </div>

                            <!-- 已生成：点击链接即可复制-->
                            <div v-else class="wxqq-box">
                                <div class="wxqq-box-bd">
                                    <!-- ✅短链接可点击复制 -->
                                    <div
                                            class="wxqq-line wxqq-link clickable-text"
                                            @click="copyShortAndText"
                                            title="点击复制短链+文案"
                                    >
                                        {{ antiBlockLink }}
                                    </div>
                                    <!-- ✅分享文案必须展示 -->
                                    <div class="wxqq-line wxqq-text" style="margin-top: 6px">
                                        【{{ shareText }}】
                                    </div>

                                </div>
                            </div>



                            <div class="safe-note">
                                <div class="note-title">使用建议</div>
                                <ul class="note-list">
                                    <li>微信/QQ 内分享优先使用防屏蔽链接</li>
                                    <li>如果提示风险/无法打开，重新生成一次再分享</li>
                                    <li>海报也建议绑定防屏蔽链接二维码</li>
                                </ul>
                            </div>
                        </div>

                    </div>

                    <!-- 快捷分享 -->
                    <div class="panel">
                        <div class="panel-title">快捷分享</div>
                        <div class="share-grid">
                            <div class="share-box" @click="goPoster">
                                <div class="share-icon"><i class="fa fa-qrcode"></i></div>
                                <div class="share-title">生成海报/二维码</div>
                                <div class="share-desc muted">适合朋友圈/群聊转发</div>
                            </div>

                            <div class="share-box" @click="goDetail">
                                <div class="share-icon"><i class="fa fa-line-chart"></i></div>
                                <div class="share-title">查看推广明细</div>
                                <div class="share-desc muted">数据走势一目了然</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- ✅ 提现确认模态框 -->
            <div v-if="withdrawModal.visible" class="pc-modal-mask" @click.self="closeWithdrawModal">
                <div class="pc-modal-card" role="dialog" aria-modal="true">
                    <div class="pc-modal-title">申请提现</div>
                    <div class="pc-modal-desc">即将跳转到【钱包中心】进行提现</div>

                    <div class="pc-modal-actions">
                        <button class="pc-modal-btn cancel" @click="closeWithdrawModal" :disabled="withdrawModal.loading">
                            取消
                        </button>
                        <button class="pc-modal-btn ok" @click="confirmWithdraw" :disabled="withdrawModal.loading">
                            {{ withdrawModal.loading ? "处理中..." : "确定" }}
                        </button>
                    </div>
                </div>
            </div>

            <!-- ✅ 提示模态框 -->
            <div v-if="copyModal.visible" class="pc-modal-mask" @click.self="closeCopyModal">
                <div class="pc-modal-card" role="dialog" aria-modal="true">
                    <div class="pc-modal-title">提示</div>
                    <div class="pc-modal-desc">{{ copyModal.text }}</div>

                    <!--<div class="pc-modal-actions">-->
                        <!--<button class="pc-modal-btn ok" @click="closeCopyModal">确定</button>-->
                    <!--</div>-->
                </div>
            </div>
        </div>

        <div class="gongxi2"></div>
        <ZhaiFootPC />
    </div>
</template>

<script>
    import ZhaiHeadPC from "../componentspc/ZhaiHeadPC";
    import ZhaiFootPC from "../componentspc/ZhaiFootPC";
    import { mapGetters } from "vuex";
    import http from "../utils/http.js";

    export default {
        name: "PPromotion",
        components: { ZhaiHeadPC, ZhaiFootPC },

        data() {
            return {
                // 数据概览
                todayIncome: 0.0,
                yesterdayIncome: 0.0,
                totalIncome: 0.0,
                myCustomers: 0,
                lastUpdate: "—",

                // 推广/防屏蔽
                promoLink: "",
                antiBlockLink: "", // 仅页面展示：必须点按钮才赋值
                genLoading: false,

                // 短链缓存（给海报/业务使用，不回显到页面）
                antiBlockLinkCache: "",

                // 分享文案
                shareText: "御凤楼-全网最真实寻欢信息分享论坛，全国千万网友验证分享！",

                inviteUid: "",
                currentUserId: null,

                // 头部占位（保留）
                headH: 0,
                ro: null,
                mql: null,
                onMqlChange: null,

                // 模态框
                withdrawModal: { visible: false, loading: false },
                copyModal: { visible: false, text: "复制成功！" },
                copyModalTimer: null,

                // 防止并发
                posterLoading: false,
                loadingPromo: false,
                loadingStats: false,
            };
        },

        computed: {
            ...mapGetters(["getUser"]),
        },

        // 路由守卫：未登录直接跳登录页
        beforeRouteEnter(to, from, next) {
            const token = localStorage.getItem("token");
            if (!token) next("/login");
            else next();
        },

        async mounted() {
            // 未登录兜底
            const token = localStorage.getItem("token");
            if (!token) {
                this.$router.replace("/login");
                return;
            }

            this.lastUpdate = new Date().toLocaleString();

            // ✅ 关键：更稳的 userId 获取（vuex 可能还没就绪）
            this.currentUserId = this.resolveUserIdSafe();

            // ✅ 关键：页面打开必须展示推广链接，所以这里立即拉 promoInfo
            //    传参方式必须匹配你的 http.get(url, params)
            await this.loadPromoInfo();

            // ✅ 再拉统计（不影响推广链接展示）
            await this.loadStatsInfo();

            // 头部高度监听（保留）
            this.mql = window.matchMedia("(min-width: 768px)");
            const apply = () => {
                if (this.mql.matches) {
                    this.startObserveHeadHeight();
                    this.updateHeadHeight();
                } else {
                    this.stopObserveHeadHeight();
                    this.headH = 0;
                }
            };
            apply();

            this.onMqlChange = () => apply();
            if (this.mql.addEventListener) {
                this.mql.addEventListener("change", this.onMqlChange);
            } else {
                this.mql.addListener(this.onMqlChange);
            }

            window.addEventListener("resize", this.updateHeadHeight, { passive: true });
        },

        beforeUnmount() {
            this.stopObserveHeadHeight();
            window.removeEventListener("resize", this.updateHeadHeight);

            if (this.mql && this.onMqlChange) {
                if (this.mql.removeEventListener) {
                    this.mql.removeEventListener("change", this.onMqlChange);
                } else {
                    this.mql.removeListener(this.onMqlChange);
                }
            }

            if (this.copyModalTimer) {
                clearTimeout(this.copyModalTimer);
                this.copyModalTimer = null;
            }
        },

        methods: {
            // ================== 工具：金额分转换 ==================
            centToYuan(cent) {
                const v = Number(cent);
                if (!Number.isFinite(v)) return 0;
                return v / 100;
            },

            // ================== 工具：更稳的 userId 获取 ==================
            resolveUserIdSafe() {
                // 1) Vuex
                const u = this.getUser || {};
                if (u && u.id) return u.id;

                // 2) localStorage 常见存法（你项目不一定有，但这样最稳）
                const tryKeys = ["user", "userinfo", "userInfo", "USER", "User"];
                for (const k of tryKeys) {
                    try {
                        const raw = localStorage.getItem(k);
                        if (!raw) continue;
                        const obj = JSON.parse(raw);
                        if (obj && obj.id) return obj.id;
                        if (obj && obj.data && obj.data.id) return obj.data.id;
                    } catch (e) {
                        // ignore
                    }
                }

                // 3) 拿不到就返回 null（后端如果 token 拦截器 setAttribute(userId) 也能跑通）
                return null;
            },

            // ================== 缓存短链（仅供海报/业务使用，不回显） ==================
            getShortLinkCacheKey() {
                return `promo_short_link_${this.currentUserId || "unknown"}`;
            },
            loadShortLinkFromCache() {
                try {
                    const key = this.getShortLinkCacheKey();
                    return localStorage.getItem(key) || "";
                } catch (e) {
                    return "";
                }
            },
            saveShortLinkToCache(shortLink) {
                if (!shortLink) return;
                try {
                    const key = this.getShortLinkCacheKey();
                    localStorage.setItem(key, shortLink);
                } catch (e) {
                    console.warn(e);
                }
            },

            // ================== 跳转 ==================
            goCustomers() {
                this.$router.push({ path: "/MyCustomers" });
            },

            goDetail() {
                this.$router.push({ path: "/PromotionDetails" });
            },
            goRules() {
                this.$router.push({ path: "/PromotionRules" });
            },

            // ✅ 生成海报：优先用缓存短链；没有才请求生成一次；但不回显到页面
            async goPoster() {
                if (this.posterLoading) return;

                const token = localStorage.getItem("token");
                if (!token) {
                    this.$router.replace("/login");
                    return;
                }

                // 尽量保证 currentUserId 有值
                if (!this.currentUserId) this.currentUserId = this.resolveUserIdSafe();

                this.posterLoading = true;
                try {
                    let shortLink = this.antiBlockLinkCache;

                    if (!shortLink) {
                        shortLink = this.loadShortLinkFromCache();
                        if (shortLink) this.antiBlockLinkCache = shortLink;
                    }

                    // 还没有：请求生成一次短链
                    if (!shortLink) {
                        // ✅ 这里必须按你的 http.post 方式：参数在 url 或 data 都行，你后端是 @RequestParam，所以放 url 最直接
                        const url = this.currentUserId
                            ? `/platform/promo/newShort?userId=${this.currentUserId}`
                            : `/platform/promo/newShort`;

                        const res = await http.post(url);
                        const json = res.data;

                        if (!json || json.status !== 1) {
                            this.openCopyModal((json && json.msg) || "生成短链接失败");
                            return;
                        }

                        const d = json.data || {};
                        shortLink = d.shortLink || "";
                        if (!shortLink) {
                            this.openCopyModal("短链接为空，生成失败");
                            return;
                        }

                        this.antiBlockLinkCache = shortLink;
                        this.saveShortLinkToCache(shortLink);

                        if (d.uidLink) this.promoLink = d.uidLink;
                        if (d.inviteUid) this.inviteUid = d.inviteUid;
                    }

                    const link = shortLink || this.promoLink;
                    this.$router.push({ path: "/PromotionPoster", query: { link } });
                } catch (e) {
                    console.error(e);
                    this.openCopyModal("生成短链接失败，请稍后重试");
                } finally {
                    this.posterLoading = false;
                }
            },

            // ✅ 点击短链复制（只针对页面展示的短链）
            copyShortAndText() {
                if (!this.antiBlockLink) {
                    this.openCopyModal("链接为空，无法复制");
                    return;
                }

                const content = `${this.antiBlockLink}\n【${this.shareText}】`;
                this.copyText(content).then((ok) => {
                    this.openCopyModal(ok ? "短链+文案已复制！" : "复制失败，请手动复制");
                });
            },

            // ================== 提现模态框 ==================
            openWithdrawModal() {
                this.withdrawModal.visible = true;
            },
            closeWithdrawModal() {
                if (this.withdrawModal.loading) return;
                this.withdrawModal.visible = false;
            },
            async confirmWithdraw() {
                if (this.withdrawModal.loading) return;

                this.withdrawModal.loading = true;
                try {
                    this.withdrawModal.visible = false;
                    this.$router.push({ path: "/WalletWithdrawal" });
                } catch (e) {
                    console.error(e);
                    this.openCopyModal("操作失败，请稍后重试");
                } finally {
                    this.withdrawModal.loading = false;
                }
            },

            // ================== 提示模态框 ==================
            openCopyModal(text, autoCloseMs = 1500) {
                this.copyModal.text = text || "复制成功！";
                this.copyModal.visible = true;

                if (this.copyModalTimer) clearTimeout(this.copyModalTimer);

                this.copyModalTimer = setTimeout(() => {
                    this.copyModal.visible = false;
                    this.copyModalTimer = null;
                }, autoCloseMs);
            },
            closeCopyModal() {
                if (this.copyModalTimer) {
                    clearTimeout(this.copyModalTimer);
                    this.copyModalTimer = null;
                }
                this.copyModal.visible = false;
            },

            // ================== 页面打开：加载推广链接（必须展示） ==================
            async loadPromoInfo() {
                if (this.loadingPromo) return;
                this.loadingPromo = true;

                try {
                    // ✅ 关键：匹配你的 http.get(url, params)
                    // 有 userId 就传，没有就不传（让后端 token 解析兜底）
                    const params = this.currentUserId ? { userId: this.currentUserId } : null;

                    const res = await http.get("/platform/promo/myInfo", params);
                    const json = res.data;

                    if (!json || json.status !== 1) {
                        // ✅ 这里才弹窗（否则 promoLink 永远不出来）
                        this.openCopyModal((json && json.msg) || "获取推广信息失败");
                        return;
                    }

                    const d = json.data || {};
                    this.promoLink = d.uidLink || "";
                    this.inviteUid = d.inviteUid || "";

                    // 页面展示短链必须用户手动点按钮生成，所以这里不回显
                    this.antiBlockLink = "";

                    // 但业务短链缓存可恢复
                    this.antiBlockLinkCache = this.loadShortLinkFromCache();

                    // ✅ 如果后端返回了最近 shortLink，你也可以选择仅缓存，不回显
                    if (!this.antiBlockLinkCache && d.shortLink) {
                        this.antiBlockLinkCache = d.shortLink;
                        this.saveShortLinkToCache(d.shortLink);
                    }
                } catch (e) {
                    console.error(e);
                    this.openCopyModal("获取推广信息失败，请稍后重试");
                } finally {
                    this.loadingPromo = false;
                }
            },

            // ================== 页面打开：加载统计 ==================
            async loadStatsInfo() {
                if (this.loadingStats) return;
                this.loadingStats = true;

                try {
                    const params = this.currentUserId ? { userId: this.currentUserId } : null;
                    const res = await http.get("/platform/promo/stats", params);
                    const json = res.data;

                    if (!json || json.status !== 1) {
                        // 统计不影响主功能：这里不强制弹窗，避免“打开就弹”
                        console.warn("[PromoStats] failed:", json);
                        return;
                    }

                    const d = json.data || {};
                    this.todayIncome = this.centToYuan(d.todayIncomeCent);
                    this.yesterdayIncome = this.centToYuan(d.yesterdayIncomeCent);
                    this.totalIncome = this.centToYuan(d.totalCommissionCent);
                    this.myCustomers = Number(d.myCustomers) || 0;
                    this.lastUpdate = new Date().toLocaleString();
                } catch (e) {
                    console.error("[PromoStats] error:", e);
                } finally {
                    this.loadingStats = false;
                }
            },

            // ================== 手动按钮：每次点击都生成新的防屏蔽链接（并回显） ==================
            async genAntiBlockLink() {
                if (this.genLoading) return;

                if (!this.currentUserId) this.currentUserId = this.resolveUserIdSafe();

                this.genLoading = true;
                try {
                    const url = this.currentUserId
                        ? `/platform/promo/newShort?userId=${this.currentUserId}`
                        : `/platform/promo/newShort`;

                    const res = await http.post(url);
                    const json = res.data;

                    if (!json || json.status !== 1) {
                        this.openCopyModal((json && json.msg) || "生成失败");
                        return;
                    }

                    const d = json.data || {};

                    // 页面展示：只展示新生成短链
                    this.antiBlockLink = d.shortLink || "";

                    // 同时更新缓存（海报入口也能直接用）
                    this.antiBlockLinkCache = this.antiBlockLink || "";
                    this.saveShortLinkToCache(this.antiBlockLinkCache);

                    if (d.uidLink) this.promoLink = d.uidLink;
                    if (d.inviteUid) this.inviteUid = d.inviteUid;

                    this.openCopyModal("防屏蔽链接生成成功！");
                } catch (e) {
                    console.error(e);
                    this.openCopyModal("生成失败，请稍后重试");
                } finally {
                    this.genLoading = false;
                }
            },

            // ================== 推广链接复制 ==================
            async onPromoInputClick(e) {
                try {
                    e?.target?.select?.();
                    e?.target?.setSelectionRange?.(0, e.target.value.length);
                } catch (err) {
                    console.warn("[Promo] select input failed", err);
                }
                await this.copyPromoLinkAndModal();
            },

            async copyPromoLinkAndModal() {
                if (!this.promoLink) {
                    this.openCopyModal("推广链接为空，请稍后重试");
                    return;
                }
                const ok = await this.copyText(this.promoLink);
                this.openCopyModal(ok ? "推广链接已复制！" : "复制失败，请手动复制");
            },

            // ================== 通用复制 ==================
            async copyText(text) {
                try {
                    if (navigator.clipboard && window.isSecureContext) {
                        await navigator.clipboard.writeText(text);
                        return true;
                    }
                } catch (e) {
                    console.warn("[Promo] clipboard failed, fallback", e);
                }

                try {
                    const ta = document.createElement("textarea");
                    ta.value = text;
                    ta.setAttribute("readonly", "");
                    ta.style.position = "fixed";
                    ta.style.left = "-9999px";
                    ta.style.top = "0";
                    document.body.appendChild(ta);
                    ta.select();
                    const ok = document.execCommand("copy");
                    document.body.removeChild(ta);
                    return ok;
                } catch (e) {
                    console.error("[Promo] execCommand copy failed", e);
                    return false;
                }
            },

            // ================== 头部高度监听（保留） ==================
            startObserveHeadHeight() {
                if (this.ro || !this.$refs.headWrap) return;

                this.ro = new ResizeObserver(() => {
                    this.updateHeadHeight();
                });
                this.ro.observe(this.$refs.headWrap);
            },
            stopObserveHeadHeight() {
                if (this.ro) {
                    this.ro.disconnect();
                    this.ro = null;
                }
            },
            updateHeadHeight() {
                if (!this.mql || !this.mql.matches) return;
                if (!this.$refs.headWrap) return;

                const h = Math.ceil(this.$refs.headWrap.getBoundingClientRect().height || 0);
                if (h !== this.headH) this.headH = h;
            },
        },
    };
</script>

<style scoped>
    /* =========================================
       ✅ 只作用在 .container.errong 内的统一圆角 2px
       ========================================= */
    .container.errong {
        --ui-radius: 2px;
    }

    .container.errong .stat-card,
    .container.errong .panel,
    .container.errong .menu-item,
    .container.errong .input,
    .container.errong .safe-note,
    .container.errong .share-box,
    .container.errong .btn-primary,
    .container.errong .btn-green,
    .container.errong .btn-ghost,
    .container.errong .mi-icon,
    .container.errong .share-icon,
    .container.errong .wxqq-box {
        border-radius: var(--ui-radius) !important;
    }

    .container.errong .panel,
    .container.errong .stat-card,
    .container.errong .menu-item,
    .container.errong .share-box,
    .container.errong .safe-note,
    .container.errong .wxqq-box {
        overflow: hidden;
    }

    .gongxi2 {
        height: 20px;
    }

    .errong {
        padding-left: 30px;
        padding-right: 30px;
    }

    .lf {
        font-weight: 900;
    }

    /* ✅ fixed 头部：动态占位 */
    @media (min-width: 768px) {
        .zhai-head-wrap {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            width: 100%;
            z-index: 1000;
        }
        .page-wrap {
            padding-top: var(--head-h, 0px);
        }
        .zhai-head {
            position: relative;
            width: 100%;
        }
    }
    @media (max-width: 767.98px) {
        .zhai-head-wrap {
            position: static;
        }
        .page-wrap {
            padding-top: 0;
        }
    }

    .page-wrap {
        min-height: calc(100vh - 120px);
    }

    .muted {
        color: #999;
    }

    /* ✅ input 更像可点击复制 */
    .container.errong .input {
        cursor: pointer;
    }
    .container.errong .input:active {
        opacity: 0.85;
    }

    /* 统计卡片区 */
    .stats-grid {
        margin-top: 10px;
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 12px;
    }
    .stat-card {
        background: #fff;
        border: 1px solid #f0f0f0;
        padding: 16px;
    }
    .stat-label {
        font-size: 13px;
        color: #888;
    }
    .stat-value {
        margin-top: 8px;
        font-size: 26px;
        font-weight: 900;
        color: #111;
    }
    .stat-foot {
        margin-top: 10px;
        font-size: 12px;
        color: #999;
    }

    /* 主体左右分栏 */
    .main-grid {
        margin-top: 10px;
        display: grid;
        grid-template-columns: 1.05fr 0.95fr;
        gap: 12px;
        align-items: start;
    }

    .panel {
        background: #fff;
        border: 1px solid #f0f0f0;
        padding: 16px;
        margin-bottom: 10px;
    }
    .panel-title {
        font-size: 15px;
        font-weight: 900;
        color: #111;
        margin-bottom: 12px;
    }

    /* 左侧菜单 */
    .menu-list {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }
    .menu-item {
        border: 1px solid #f2f2f2;
        padding: 12px 12px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;
        transition: all 0.15s ease;
    }
    .menu-item:hover {
        border-color: rgba(0, 194, 111, 0.35);
        box-shadow: 0 6px 18px rgba(0, 0, 0, 0.05);
        transform: translateY(-1px);
    }
    .mi-left {
        display: flex;
        align-items: center;
        gap: 12px;
    }
    .mi-icon {
        width: 35px;
        height: 35px;
        border: 2px solid #e6e6e6;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .mi-icon .fa {
        margin-right: 0;
        color: #ff4d4f;
        font-size: 16px;
    }
    .mi-title {
        font-size: 14px;
        font-weight: 800;
        color: #111;
    }
    .mi-desc {
        margin-top: 2px;
        font-size: 12px;
        color: #999;
    }
    .mi-right {
        color: #bbb;
        font-size: 22px;
        line-height: 1;
    }
    .mi-tag {
        color: #00c26f;
        font-size: 14px;
        font-weight: 800;
    }

    /* 表单区 */
    .field {
        margin-top: 6px;
    }
    .field-label {
        font-size: 13px;
        font-weight: 700;
        color: #333;
        margin-bottom: 8px;
    }
    .field-row {
        display: flex;
        gap: 10px;
        align-items: center;
    }
    .input {
        flex: 1;
        height: 42px;
        border: 1px solid #eaeaea;
        padding: 0 12px;
        outline: none;
        font-size: 14px;
        background: #fafafa;
    }
    .field-help {
        margin-top: 8px;
        font-size: 12px;
    }
    .divider {
        height: 1px;
        background: #f0f0f0;
        margin: 14px 0;
    }

    /* 建议说明 */
    .safe-note {
        margin-top: 10px;
        background: rgba(0, 194, 111, 0.06);
        border: 1px dashed rgba(0, 194, 111, 0.35);
        padding: 12px;
    }
    .note-title {
        font-weight: 900;
        color: #111;
        margin-bottom: 8px;
        font-size: 13px;
    }
    .note-list {
        margin: 0;
        padding-left: 18px;
        color: #555;
        font-size: 13px;
    }
    .note-list li {
        margin: 6px 0;
    }

    /* tips */
    .tips {
        display: grid;
        gap: 10px;
    }
    .tip-item {
        display: flex;
        gap: 10px;
        align-items: flex-start;
        color: #555;
        font-size: 13px;
    }
    .tip-item .fa {
        color: #00c26f;
        margin-top: 2px;
    }

    /* 右侧快捷分享 */
    .share-grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 12px;
    }
    .share-box {
        border: 1px solid #f2f2f2;
        padding: 14px;
        cursor: pointer;
        transition: all 0.15s ease;
    }
    .share-box:hover {
        border-color: rgba(0, 194, 111, 0.35);
        box-shadow: 0 6px 18px rgba(0, 0, 0, 0.05);
        transform: translateY(-1px);
    }
    .share-icon {
        width: 35px;
        height: 35px;
        border: 2px solid #e6e6e6;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .share-icon .fa {
        margin-right: 0;
        color: #ff4d4f;
        font-size: 18px;
    }
    .share-title {
        margin-top: 10px;
        font-weight: 900;
        color: #111;
    }
    .share-desc {
        margin-top: 4px;
        font-size: 12px;
    }

    /* 按钮 */
    .btn-primary {
        height: 38px;
        padding: 0 14px;
        border: none;
        color: #fff;
        font-weight: 800;
        cursor: pointer;
        background: linear-gradient(90deg, #00c26f, #19d184);
        display: inline-flex;
        align-items: center;
        gap: 8px;
    }
    .btn-green {
        height: 42px;
        padding: 0 14px;
        border: none;
        color: #fff;
        font-weight: 800;
        cursor: pointer;
        background: linear-gradient(90deg, #00c26f, #19d184);
        display: inline-flex;
        align-items: center;
        gap: 8px;
        white-space: nowrap;
    }
    .btn-ghost {
        height: 38px;
        padding: 0 12px;
        border: 1px solid #eaeaea;
        background: #fff;
        cursor: pointer;
        font-weight: 800;
        color: #333;
        display: inline-flex;
        align-items: center;
        gap: 8px;
    }
    .btn-ghost:hover {
        border-color: rgba(0, 194, 111, 0.35);
    }

    /* 响应式 */
    @media (max-width: 1100px) {
        .stats-grid {
            grid-template-columns: repeat(2, 1fr);
        }
        .main-grid {
            grid-template-columns: 1fr;
        }
    }

    /* ================= 防屏蔽：单大框两行 ================= */
    .wxqq-head {
        display: flex;
        align-items: center;
        gap: 12px;
        justify-content: flex-start; /* ✅ 改成靠左排 */
    }
    .wxqq-title {
        font-size: 13px;
        font-weight: 800;
        color: #333;
    }
    .wxqq-actions {
        margin-left: auto; /* 先推到右边 */
        padding-right: 50px; /* ✅ 再整体往左挪（调这个数） */
    }

    .wxqq-box {
        border: 1px solid #f0f0f0;
        background: #fff;
        margin-top: 6px;
    }

    .wxqq-box-hd {
        padding: 10px 12px;
        border-top: 1px solid #f0f0f0;
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        gap: 12px;
    }
    .wxqq-box-title {
        font-weight: 900;
        color: #111;
    }
    .wxqq-box-sub {
        margin-top: 2px;
        font-size: 12px;
    }
    .wxqq-expire {
        font-weight: 800;
        font-size: 12px;
        color: #666;
        white-space: nowrap;
    }
    .wxqq-expired {
        color: #e53935;
    }

    .wxqq-box-bd {
        padding: 12px;
    }

    .wxqq-line {
        word-break: break-all;
        font-size: 14px;
        line-height: 1.6;
    }
    .wxqq-link {
        font-weight: 800;
        color: #111;
    }
    .wxqq-text {
        margin-top: 6px;
        font-weight: 800;
        color: #111;
    }

    .wxqq-box-ft {
        padding: 10px 12px 12px;
        border-top: 1px solid #f0f0f0;
        display: flex;
        align-items: center;
        gap: 12px;
        flex-wrap: wrap;
    }

    .wxqq-warn {
        font-size: 12px;
        color: #e53935;
        font-weight: 800;
    }
    .wxqq-tip {
        font-size: 12px;
    }

    /* 可点击复制 */
    .clickable-text {
        cursor: pointer;
        user-select: text;
    }
    .clickable-text:active {
        opacity: 0.75;
    }

    /* ================= PC 模态框（提现/复制提示共用） ================= */
    .pc-modal-mask {
        position: fixed;
        inset: 0;
        z-index: 9999;
        background: rgba(0, 0, 0, 0.55);
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 18px;
    }
    .pc-modal-card {
        width: 100%;
        max-width: 520px;
        background: #fff;
        border-radius: 6px;
        overflow: hidden;
        box-shadow: 0 18px 60px rgba(0, 0, 0, 0.25);
    }
    .pc-modal-title {
        text-align: center;
        font-size: 18px;
        font-weight: 700;
        padding: 20px 18px 10px;
        color: #111827;
    }
    .pc-modal-desc {
        text-align: center;
        font-size: 14px;
        color: #6b7280;
        padding: 0 18px 18px;
    }
    .pc-modal-actions {
        display: flex;
        border-top: 1px solid #eef0f5;
    }
    .pc-modal-btn {
        flex: 1;
        height: 52px;
        border: 0;
        background: #fff;
        font-size: 16px;
        cursor: pointer;
    }
    .pc-modal-btn:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }
    .pc-modal-btn.cancel {
        color: #6b7280;
        border-right: 1px solid #eef0f5;
    }
    .pc-modal-btn.ok {
        color: #e53935;
        font-weight: 700;
    }
    .pc-modal-btn:active:not(:disabled) {
        background: #f6f7fb;
    }
</style>
